// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BHZb","buttons":"styles_buttons__1mTVO"};